import { ROUTES } from 'constants.js';

export const isCardActive = (currentUrl, cardUrl) => {
  return currentUrl?.includes(cardUrl);
};

export const calculatePercentage = onboardingStatus => {
  if (!onboardingStatus) return 0;
  const totalSteps = Object.keys(onboardingStatus).length;
  const completedSteps = Object.values(onboardingStatus).filter(status => status === true).length;

  return (completedSteps / totalSteps) * 100;
};

export const getLinkText = ({ translateText, pageUrl }) => {
  if (pageUrl === '/credit_account') {
    pageUrl = 'creditAccount';
  }
  return `${translateText('corporateAccounts.actions.goToPage', {
    pageName: `${translateText(
      `corporateAccounts.menuLeft.${pageUrl.replace(/^\//, '')}`,
    ).toLowerCase()}`,
  })} ➔`;
};

const PAYMENT_STEP_URLS = [ROUTES.PAYMENTS, ROUTES.CREDIT_ACCOUNT, ROUTES.WALLET];

// Only one of the payment steps is shown: the wallet for wallet onboarding, else the credit
// account while its step is active, else the payment methods.
export const getPaymentStepUrl = ({ isWalletOnboarding, isCreditAccountStepActive }) => {
  if (isWalletOnboarding) return ROUTES.WALLET;
  return isCreditAccountStepActive ? ROUTES.CREDIT_ACCOUNT : ROUTES.PAYMENTS;
};

export const isOnboardingStepDisplayed = (stepUrl, paymentStepUrl) =>
  !PAYMENT_STEP_URLS.includes(stepUrl) || stepUrl === paymentStepUrl;
